import { Component, Input, OnInit } from '@angular/core';
import { Parameter } from 'src/app/apps/dashboard/dashboard';

@Component({
  selector: 'app-params-base',
  templateUrl: './params-base.component.html',
  styleUrls: ['./params-base.component.less'],
})
export class ParamsBaseComponent implements OnInit {
  @Input() parameters: Parameter[];
  @Input() dashboardParams: string[];
  @Input() dashboardParamNames: string[];
  @Input() dashboardId: number;
  constructor() {}

  ngOnInit(): void {
    console.log(this.parameters);
  }
}
